export default __webpack_public_path__ + "static/media/lease_management_icon.12dfc818.png";